import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "reactstrap"
import MetaTags from "react-meta-tags"

//Import Components
import CardUser from "./card-user"
import CardWelcome from "./card-welcome"
import MiniWidget from "./mini-widget"

import SalesAnalytics from "./sales-analytics"
//import TotalSellingProduct from "./total-selling-product"
import Tasks from "./tasks"
//import ChatBox from "./chat-box"
import Notifications from './notifications';
import Oerview from './overview';
import User from "./user"

import axios from "axios";
import * as url from "helpers/url_helper";
import { Config, formatDate } from "helpers/backend_helper";

const HRDashboard = props => {
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(true);

  const [username, setusername] = useState("--")
  const [role, setRole] = useState("--")


  const [yourLeaves, setYourLeaves] = useState([])

  const [waterProduced, setWaterProduced] = useState({"inflow":"--","outflow":"--","power":"--"});
  const [mtcJobs, setMTCJOBS] = useState("--");
  const [hrProfile, setHRProfile] = useState(false)
  const [staffData, setStaffData] = useState({})

  const fetchData = async () =>{
    setLoading(true)
    try {
      const r = await axios.get(url.HRDASHEMPLOYEES, Config)
      setStaffData(r.data)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (localStorage.getItem("authWTUser")) {
        const obj = JSON.parse(localStorage.getItem("authWTUser"))
        setusername(obj.username)
        setRole(obj.title)
        if(obj.hrId == ""){
          setHRProfile(false)
        }else{
          setHRProfile(true)
        }
    }
    fetchData()
  }, [])
  
  useEffect(()=> {
    const leave = [

      {
        'leaveType': 'Response Time', 
        'entitled': "< 3 hours",
        'balance': "-"
      },
      {
        'leaveType': 'Fault Correction Time', 
        'entitled': "< 6 hours",
        'balance': "-"
      },
      {
        'leaveType': 'Uptime', 
        'entitled':"> 90%",
        'balance': "-"
      },
      {
        'leaveType': 'Mean Time Between Failure ', 
        'entitled': "> 1 year",
        'balance': "-"
      },
      {
        'leaveType': 'Emergency Works', 
        'entitled':"< 10%",
        'balance': "-"
      },
      {
        'leaveType': 'Planned Tasks', 
        'entitled': "> 80%",
        'balance': "-"
      },
      {
        'leaveType': 'Maintenance Backlog', 
        'entitled': "< 4 Weeks",
        'balance': "-"
      },
      {
        'leaveType': 'Overtime/subsistence', 
        'entitled': "< 12%",
        'balance': "-"
      },
      {
        'leaveType': 'Maintenance Labour Cost', 
        'entitled': "< 25% of TMC",
        'balance': "-"
      }

    ];
    setYourLeaves(leave)
  },[])



 

  const reports = [
    {
      icon: "bx bx-copy-alt",
      title: "Active Staff",
      value: staffData.active,
      color: "success"
    },
    {
      icon: "bx bxs-message-square-dots",
      title: "Suspended",
      color: "warning",
      value: staffData.suspended
    }
    ,
    {
      icon: "bx bxs-message-square-dots",
      title: "Retired",
      color: "secondary",
      value: staffData.retired
    },
    {
      icon: "bx bxs-book-bookmark",
      title: "Terminated",
      value: staffData.terminated,
      color: "danger",
    }
];



  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>
            Human Resources Dashboard | {url.COMPANY}
          </title>
        </MetaTags>
        <Container fluid>
  
        
          <Row>
            
            <Col xl="12">
              <Row>
                <User reports={reports}/>
              </Row>
            </Col>
            <Oerview /> 
          </Row>


          {/*
          <Row>
            <Notifications approvals={approvals}/>
            <Tasks leave={yourLeaves} showReports={true} />
          </Row>
          */}
         
       
          
        
     
        </Container>
      </div>
    </React.Fragment>
  )
}

export default HRDashboard
